import React from "react";
import { useIsMobile } from "@/app/redux/features/device/selectors";

export function TermsAndConditions() {
  const isMobile = useIsMobile();

  return (
    <div className={"-mx-4 lg:mx-0 flex-center h-10 lg:h-[70px] py-2 lg:py-4 font-jost relative bg-[#E7E7E9]"}>
      <div
        className={
          isMobile
            ? "relative size-full flex items-center justify-center"
            : "absolute bg-[#E7E7E9] z-[1] left-0 inset-y-0 w-[calc(calc(100vw-260px-48px)-calc(100vw-1360px-48px)/2)] flex items-center justify-center"
        }>
        <a
          href={"https://www.botb.com/assets/docs/christmas-raf-tc.pdf"}
          target={"_blank"}
          className={"text-gray-1 !underline text-center text-xs font-normal lg:text-base lg:leading-5.5"}>
          View Terms and Conditions
        </a>
      </div>
    </div>
  );
}
